<!--
input 요소에 대한 추상 컴포넌트
각 input 요소는 이 컴포넌트를 extend 해서 템플릿부분만 재정의하는쪽으로 개발됨

---------------------------
TODO : 부모 컴포넌트가 value 속성에 바인딩하지 않은경우에도 컴포넌트 내부의 input 요소의 값이 변경되도록 해야함
ex) <app-input-text></app-input-text> 이렇게하면, 부모와 동기화된 value 가 없기때문에, 값을 작성해도 텍스트박스가 계속 초기화됨 

-->
<script>
    export default {
    // v-model 처리
    model: {
        prop: 'value',
        event: 'update:value'
    },
    props: {
        id: String,
        name: String,
        /**
         * 플레이스 홀더
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * input 요소의 값
         */
        value: {
            type: [String, Number],
            default: ''
        },
        /**
         * input 요소 사이즈
         *  - small
         *  - large
         * */
        inputSize: {
            type: String,
            default: null
        },
        /**
         * 검증규칙
         *      - 검증규칙객체 : approvejs
         *        참고 ) https://charlgottschalk.github.io/approvejs/docs/tests/
         *      - 검증 Promise 생성 콜백 함수명
         *        function callback(cmp) { return Promise}
         **/
        validateRules: {
            default: null
        },
        /**
         * 셀렉트 박스나, 라디오에서 사용할 옵션객체 배열 ex) [{text: '텍스트', val: 'a'}, {text: 'b', val: 'c'}]
         *      - selected 기능 제공하지 않음 ex ) {text: 'b', val: 'c', selected: true}
         *        컴포넌트의 value 속성을 설정해서, selected, checked  여부를 컨트롤 하도록 한다
         */
        options: {
            type: Array,
            default: null
        },
        /**
         * 초기 오류메세지 설정
         */
        initErrorMsg: {
            type: String,
            default: null
        },
        /**
         * TEXTAREA 의 rows 속성
         */
        textareaRows: { 
            type: Number,
            default: 5
        },
        /**
         * TEXT 의 style 속성
         */
        textStyle: {
            type: String,
            default: null,
        },
        /**
         * readonly 속성
         */
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },

        /**
         * css 변수정의
         * 전달 예 :
         * <app-input-ex :css-variables="{'--label-highlight-bg-color': 'red'}" />
         */
        cssVariables: {
            type: Object,
            default: () => { return {}; }
        },
    },
    data: function () {

        return {
            // 검증 처리 상태, ing : 검증중, success : 성공, error : 오류
            validateState: '', 
            // 포커싱 여부
            isFocus: false,
            // 에러메세지
            errorMsg: ''
        };
    },
    computed: {
        /**
         * 디폴트 css 변수정의
         * --bg-color: input요소 배경색
         */
        defaultCssVariables: function () {
            return {
                 '--bg-color': '#fff'
            };
        },

        /**
         * 클래스 명
         * */
        classObject: function () {
            return {
                'focus': this.isFocus,
                'validate-error': this.validateState === 'error',
                'validate-ing': this.validateState === 'ing',
                'validate-success': this.validateState === 'success'
            }
        },
        /**
         * input 요소 사이즈 클래스명
         */
        inputSizeClass: function () {
            if (this.inputSize === 'small') {
                return 'uk-form-small';
            } else if (this.inputSize === 'large') {
                return 'uk-form-large';
            }
            return '';
        },
        /**
         * 검증 등록 여부
         * */
        hasValidation: function() {
            //console.log(this.validateRules);
            // 검증규칙있으면 실행
            if (this.validateRules) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * 라이브 검증 실행여부
         * */
        isOnLiveValidate: function() {
            return this.hasValidation; // 검증이 등록되면 무조건 라이브검증 실행
        },

        /**
         * customPlaceholder 슬롯 화면표시여부
         * 내용이 입력되면 화면에서 사라져야함.
         * @return bool
         */
        visibleCustomPlaceholder () {
            return this.$slots.customPlaceholder
                && (! this.value);
        }
    },
    watch: {
        /**
         * 값이 변경되는 것을 감시해서, 라이브 검증 처리
         */
        value: function () {
            this.liveValidate(true);
        }
    },
    mounted: function () {

        // 초기 오류 설정
        if (this.initErrorMsg) {
            this.setState('error', this.initErrorMsg);
        }
        
    },
    methods: {
        focus: function () {
            this.setFocusState(true);
        },
        focusout: function () {
            this.setFocusState(false);
        },
        /**
         * isFocus 의 상태를 설정한다.
         * @param bool 상태
         */
        setFocusState: function (bool) {
            this.isFocus = bool;
            this.$emit('update:is-focus', bool); // 이벤트 발생

            // 포커스 아웃되면, 라이브 검증 한번 함.
            if (! bool) {
                this.liveValidate(false);
            }
            
        },
        /**
         * 현재 컴포넌트의 input 요소에 포커스를 준다.
         * */
        inputFocus: function () {
            // 크롬 버그로 focus()를 주면 바로 동작안할때가 있어서 setTimeout을 통해서 약간 딜레이를 줘야 정상동작함.
            let input = $(this.$el).find(':input');
            setTimeout(function () {
                input.focus();
            }, 50);
        },
        /**
         * input 의 값이 변경되었음을 알리는 이벤트 발생
         *  - 리스너에 변경된 값을 인자로 전달
         * @param event vue 이벤트 객체
         * */
        updateValue: function (event) {
            this.$emit('update:value', event.target.value);
        },
        /**
         * 검증상태를 설정한다
         * @param state 상태
         *          - 'ing'
         *          - 'success'
         *          - 'error'
         * @param errmsg  오류메세지
         */
        setState: function (state, errmsg) {
            this.validateState = state;

            // 오류 메세지가 존재하고 오류상태일때만 메세지 설정
            if (errmsg && state === 'error') {
                this.errorMsg = errmsg;    
            } else {
                this.errorMsg = '';    
            }

            // 이벤트 발생
            this.$emit('update:state', this.validateState, this.errorMsg);
            
        },
        /**
         * 검증 처리 Promise를 반환
         **/
        getValidatePromise: function () {
            let cmp = this; // 뷰 컴포넌트 객체
            let rules = cmp.validateRules;


            // 프라미스 생성
            let promise = null;
            if ($.type(rules) == 'string') {
                // 함수명인 경우
                promise = $.app.util.call_func(rules, window, cmp);

            } else {
                // 검증 규칙 객체인 경우

                promise = new Promise(function (resolve, reject) {
                    // 검증
                    //if (! rules.title) rules.title = cmp.label;
                    let result = approve.value(cmp.value, rules);

                    // 검증 결과처리
                    if (result.approved) {
                        resolve();
                    } else {
                        reject(result.errors[0]);// 첫번째 오류메세지 설정
                    }
                });
            }
            return promise;

        },
        /**
         * 라이브 검증 실행
         * @param is_debounce debounce여부
         */
        liveValidate: function (is_debounce) {
            // 라이브검증 설정 되어있을때만 검증실행
            if ( this.isOnLiveValidate) {
                if (is_debounce) {
                    this.debounceValidate();
                } else {
                    this.validate();
                }
                
            }
        },
        /**
         * debounce 처리되어 validate 호출
         */
        debounceValidate: _.debounce(function () {
            this.validate();
        }, 500),
        /**
         * 검증 실행
         */
        validate: function () {
            // 검증이 등록 안되어있으면 종료
            if (! this.hasValidation) {
                return;
            }
            
            let cmp = this; // 뷰 컴포넌트 객체
            let value = cmp.value; // 검증이 이루어질 값, 추후에 검증과정중에 값이 변경되었는지 검사함.

            // 검증중 이면 먼저 검증이 끝날때까지 검증안함.
            if (this.validateState === 'ing') {
                return;
            }
            cmp.setState('ing');

            // 검증 프라미스 실행
            let promise = this.getValidatePromise();
            promise.then(function () {
                // resolve
                cmp.setState('success');
                //console.log('success');

            }, function (reason){
                // reject
                cmp.setState('error', reason);
                //console.log('error');

            }).finally(function () {
                //console.log('finally');
                // 검증이 실행되는동안 값이 변경되었으면 검증을 다시 실행
                if (value !== cmp.value) {
                    cmp.validate();
                }

            });

        },
    }
};
</script>

<style lang="scss" scoped>
    .validate-ing {// 검증-중 상태
        input, select, textarea {
            border-color: #666;
        }
    }
    .validate-success {// 검증-성공 상태
        input, select, textarea {
            border-color: #009a67;
        }
    }
    .validate-error {// 검증-오류 상태
        input, select, textarea {
            border-color: #f0506e;
        }
    }
    .focus {//포커싱 상태
        input, select, textarea {
            border-color: #1e87f0;
        }
    }

    // input 요소 가운데 정렬
    .text-center{
        input,
        select,
        textarea {
            text-align: center;
        }
    }

    // fixed 요소 텍스트 출력(span)
    .fixed {
        //padding-top: 7px;
    }


    input,
    textarea,
    select option,
    .multiselect__tags {
        background-color: var(--bg-color);
    }

</style>